<template>
    <div class="text-center" v-if="value">
        <a class="m-nav-grid__item" :href="'/blog/'+value" target="_blank" v-on:click.stop>
            <i class="m-nav-grid__icon flaticon-time"></i>
        </a>
    </div>
</template>

<script>
export default {
    props: ['value'],
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/links/Blog.vue